import CurrencyValueUIModel from './currency-value';

class EMDVoucherRs {
  constructor({
    errors = undefined,
    currentStatus = undefined,
    firstName = undefined,
    lastName = undefined,
    balance = undefined,
    number = undefined,
    valid = undefined,
    originalReservation = undefined,
  } = {}) {
    this.errors = errors;
    this.currentStatus = currentStatus;
    this.firstName = firstName;
    this.lastName = lastName;
    this.balance = balance ? new CurrencyValueUIModel(balance) : null;
    this.valid = valid;
    this.number = number ? number : null;
    this.originalReservation = originalReservation ? originalReservation : null;
  }

  getNumberVoucher() {
    return this.number;
  }

  getErrorVoucher() {
    return this.errors;
  }

  getTotal() {
    return this.balance ? this.balance.getTotal() : null;
  }

  isValid() {
    return this.valid;
  }
}

export default EMDVoucherRs;
